import { isRecord } from '@bxp-framework/utils';
export function isEnterprisePricingTier(tier) {
    if (!isRecord(tier)) {
        return false;
    }
    return (typeof tier.at === 'number' &&
        typeof tier.above === 'number');
}
export function isEnterprisePricingTiers(tiers) {
    if (!Array.isArray(tiers)) {
        return false;
    }
    return tiers.every(isEnterprisePricingTier);
}
//# sourceMappingURL=type-guards.js.map